import { getMethodWithToken } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const GET_SCANNED_MASK = 'GET_SCANNED_MASK';
export const GET_SCANNED_MASK_SUCCESS = 'GET_SCANNED_MASK_SUCCESS';
export const GET_SCANNED_MASK_FAILURE = 'GET_SCANNED_MASK_FAILURE';

// Action Creators
export const getScannedMask = () => ({
  type: GET_SCANNED_MASK,
});

export const getScannedMaskSuccess = (users) => ({
  type: GET_SCANNED_MASK_SUCCESS,
  payload: users,
});

export const getScannedMaskFailure = (error) => ({
  type: GET_SCANNED_MASK_FAILURE,
  payload: error,
});

// Thunk Function
export const getScannedMaskCallAPI = (data, external) => {
  return async (dispatch) => {
    dispatch(getScannedMask());
    try {
      const response = await getMethodWithToken(url.scannedMask + data);
      if (response?.status === 200 || response?.status === 201) {
        dispatch(getScannedMaskSuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
      }
    } catch (error) {
      dispatch(getScannedMaskFailure(error?.message));
    }
  };
};
